/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
var _live;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-14 19:17:20
 */


import Vue from 'vue';
import Config from '../config/index.js';
import request from '@/utils/request';
import { upload } from '@/utils/request';
var baseUrl = '/rest/ysh/wx/v_718';
export var getChannelById = function getChannelById(data) {
  // 获取专区名 参数 channelId  必须传
  return Vue.http.post('/rest/ysh/wx/channel/getChannelById', data);
};
export var sendMessageCode = function sendMessageCode(data) {
  // 获取短信验证码
  return Vue.http.post('/rest/ysh/wx/user/sendMessageCode', data);
};
export var tmpSetUserSession = function tmpSetUserSession(data) {
  // 模拟登录
  return Vue.http.get('/rest/ysh/wx/signIn/tmpSetUserSession?userId=924822');
};
export var hospitalList = function hospitalList(data) {
  // 获取医院
  return Vue.http.post('/hospital/list', data);
};
export var registUser = function registUser(data) {
  // 用户注册
  return Vue.http.post('/rest/ysh/wx/user/registUser', data);
}; // 用户注销

export var accountLogout = function accountLogout(data) {
  return Vue.http.post('/rest/ysh/wx/user/accountLogout', data);
}; // 图形验证码

export var verifyImgCode = '/rest/ysh/wx/user/verifyImgCode';
export var getUsersData = function getUsersData(data) {
  // 获取用户信息
  return Vue.http.post('/rest/ysh/wx/user/userData', data);
};
export var userInfoRecord = function userInfoRecord(data) {
  // 提交完善信息
  return Vue.http.post('/userInfoRecord', data);
};
export var klnPublicJump = function klnPublicJump(data) {
  //康乐宁嵌套微信页面访问
  return Vue.http.post('/kln/klnPublicJump', data);
};
export var courseReport = function courseReport(data) {
  //微信听课上报
  return Vue.http.post('/rest/ysh/wx/course/report', data);
};
export var shareCallback = function shareCallback(data) {
  //分享加积分
  return Vue.http.get('/rest/ysh/wx/userCenter/shareCallback', data);
};
export var clearExpireSession = function clearExpireSession(data) {
  //清楚用户session
  return Vue.http.post('/user/clearExpireSession', data);
};
export var reportLogin = function reportLogin(data) {
  //更新用户登陆时间
  return Vue.http.post('/user/reportLogin', data);
};
export var carveIntegralSignIn = function carveIntegralSignIn(data) {
  //签到课程
  return Vue.http.post('/carveIntegral/signIn', data);
}; //注册用户关联未注册时所抢红包

export var relateRedPackToUser = function relateRedPackToUser(data) {
  return Vue.http.post('/answer/relateRedPackToUser', data);
}; // 每日任务

export var everyDayTask = function everyDayTask(data) {
  return Vue.http.get('/rest/ysh/wx/userCenter/wxEveryDayTask', data);
};
/*
 * homePage
 * */

export var home = {
  indexBannerCategory: function indexBannerCategory() {
    //  轮播
    return Vue.http.post('/rest/ysh/wx/homePage/banner');
  },
  indexLivingCourse: function indexLivingCourse() {
    // 直播列表
    return Vue.http.post('/rest/ysh/wx/homePage/todayLiveCourse');
  },
  indexList: function indexList() {
    // 头条
    return Vue.http.post('/rest/ysh/wx/homePage/headLine');
  },
  indexHotList: function indexHotList(data) {
    // 热门课程
    return Vue.http.post('/rest/ysh/wx/homePage/hotCourse', data);
  },
  indexChannel: function indexChannel(data) {
    // 首页专区
    return Vue.http.post('/rest/ysh/wx/homePage/indexChannel', data);
  },
  indexAdvList: function indexAdvList() {
    // 首页浮层控制台
    return Vue.http.post('/rest/ysh/wx/homePage/controlPanel');
  }
};
/*
 * 录播课程
 * */

export var course = {
  indexHotList: function indexHotList(data) {
    // 热门list
    return Vue.http.post('/course/indexHotList', data);
  },
  wxdetail: function wxdetail(data) {
    // detail
    return Vue.http.post('/rest/ysh/wx/course/detail', data);
  },
  chapters: function chapters(data) {
    // 章节
    return Vue.http.post('/course/chapters', data);
  },
  getByCourseId: function getByCourseId(data) {
    // 关联学院
    return Vue.http.post('/channel/getByCourseId', data);
  },
  indexCategory: function indexCategory() {
    //分类数据
    return Vue.http.post('/rest/ysh/wx/homePage/category');
  },
  courseList: function courseList(data) {
    //列表
    return Vue.http.post('/rest/ysh/wx/course/list', data);
  },
  isLiveing: function isLiveing(data) {
    // 查看课程直播状态
    return Vue.http.post('/promotion/isLiveing', data);
  },
  randomRecommend: function randomRecommend(data) {
    // 课程推荐
    return Vue.http.post('/rest/ysh/wx/course/randomRecommend', data);
  }
};
/*
 * 签到
 * */

export var signIn = {
  questions: function questions(data) {
    // 获取题
    return Vue.http.post('/rest/ysh/wx/course/question', data);
  },
  ansGetScore: function ansGetScore(data) {
    // 听课签到答题获得积分
    return Vue.http.post('/rest/ysh/wx/course/signIn', data);
  },
  courseSign: function courseSign(data) {
    //听课签到接口  todo 判断是否为直播状态 暂时没用到 BUG 应该是直播中 或者 录播 才可以签到
    return Vue.http.post('/promotion/isLiveing', data);
  }
};
/*
 * 专区
 * */

export var zone = {
  doList: function doList(data) {
    //  列表
    return Vue.http.post('/rest/ysh/wx/channel/channelList', data);
  },
  doDetail: function doDetail(data) {
    // 详情
    return Vue.http.post('/rest/ysh/wx/channel/channelDetail', data);
  },
  relationResourceItem: function relationResourceItem(data) {
    // 学院关联资源
    return Vue.http.post('/rest/ysh/wx/channel/channelContent', data);
  },
  category: function category(data) {
    // 分类数据
    return Vue.http.post('/rest/ysh/wx/channel/getFirstCategory', data);
  }
};
/*
 * 头条
 * */

export var headline = {
  list: function list(data) {
    //  列表
    return Vue.http.post('/read/list', data);
  },
  argotList: function argotList(data) {
    //  暗语列表
    return Vue.http.post('/rest/ysh/wx/watchword/obtainTodayInformation', data);
  },
  watchwordBanner: function watchwordBanner(data) {
    //  暗语列表banner列表
    return Vue.http.post('/rest/ysh/wx/watchword/watchwordBanner', data);
  },
  detail: function detail(data) {
    // 资讯详情
    return Vue.http.post('/rest/ysh/wx/info/newsDetail', data);
  },
  caseDetail: function caseDetail(data) {
    // 病例详情
    return Vue.http.post('/rest/ysh/wx/info/caseDetail', data);
  },
  noteDetail: function noteDetail(data) {
    // 帖子详情
    return Vue.http.post('/rest/ysh/wx/info/noteDetail', data);
  },
  judgeWatchwordInfo: function judgeWatchwordInfo(data) {
    // 是否为暗语资讯
    return Vue.http.post('/rest/ysh/wx/watchword/judgeWatchwordInfo', data);
  },
  obtainWatchword: function obtainWatchword(data) {
    // 获取活动暗语
    return Vue.http.post('/rest/ysh/wx/watchword/obtainWatchword', data);
  },
  ifPrizeDraw: function ifPrizeDraw(data) {
    // 今天是否抽过奖
    return Vue.http.post('/rest/ysh/wx/watchword/ifPrizeDraw', data);
  },
  drizeDraw: function drizeDraw(data) {
    // 转盘抽奖
    return Vue.http.post('/rest/ysh/wx/watchword/drizeDraw', data);
  },
  toPushInfo: function toPushInfo(data) {
    // 订阅
    return Vue.http.post('/user/toPushInfo', data);
  },
  subInformationRelationDepartment: function subInformationRelationDepartment(data) {
    // 内容中的订阅
    return Vue.http.post('/read/subInformationRelationDepartment', data);
  },
  getShare: function getShare(data) {
    // 落地分享页的轮播信息
    return Vue.http.post('/dailyInformation/currentInfo?pageStart=0&pageCount=1');
  },
  newList: function newList(data, cancelToken) {
    return Vue.http.post('/rest/ysh/wx/info/topNews', data, cancelToken);
  },
  contentList: function contentList(data, cancelToken) {
    return Vue.http.post('/rest/ysh/wx/info/caseShare', data, cancelToken);
  },
  forumDetail: function forumDetail(data) {
    return Vue.http.post('/forumPage/forumDetail', data);
  },
  bingliCategory: function bingliCategory(data) {
    return Vue.http.post('/rest/ysh/wx/info/topicList', data);
  }
};
/*
 * 直播
 * */

export var live = (_live = {
  advance: function advance() {
    //  预告
    return Vue.http.post('/rest/ysh/wx/course/livePreview');
  },
  wxCourseBook: function wxCourseBook(data) {
    //  课程报名
    return Vue.http.post('/rest/ysh/wx/course/signUp', data);
  },
  sendRepresentCoursePoster: function sendRepresentCoursePoster(data) {
    //  人人课代表
    return Vue.http.post('/rest/ysh/wx/subjectRepresent/sendRepresentCoursePoster', data);
  }
}, _defineProperty(_live, "sendRepresentCoursePoster", function sendRepresentCoursePoster(data) {
  //  课代表-报名直播课程发海报/扫二维码userId courseId visiterId
  return Vue.http.post('/rest/ysh/wx/subjectRepresent/sendRepresentCoursePoster', data);
}), _defineProperty(_live, "wxdetail", function wxdetail(data) {
  // detail
  return Vue.http.post('/rest/ysh/wx/course/detail', data);
}), _defineProperty(_live, "getByCourseId", function getByCourseId(data) {
  // 关联学院
  return Vue.http.post('/channel/getByCourseId', data);
}), _defineProperty(_live, "liveEndRecommendVideoCourse", function liveEndRecommendVideoCourse(data) {
  // 微信直播结束推荐课程
  return Vue.http.post('/rest/ysh/wx/course/liveEndRecommendVideoCourse', data);
}), _defineProperty(_live, "isLiveing", function isLiveing(data) {
  // 查看课程直播状态
  return Vue.http.post('/promotion/isLiveing', data);
}), _defineProperty(_live, "getQue", function getQue(data) {
  // 获取直播中的答题
  return Vue.http.post('/courseVoteActivity/questionList', data);
}), _defineProperty(_live, "sendAns", function sendAns(data) {
  // 提交答案
  return Vue.http.post('/courseVoteActivity/post', data);
}), _defineProperty(_live, "getGiftList", function getGiftList() {
  // 获取直播礼物
  return Vue.http.get('/rest/ysh/wx/course/getGift');
}), _defineProperty(_live, "sendGift", function sendGift(data) {
  // 送礼物（改为送积分）
  return Vue.http.post('/rest/ysh/wx/course/sendGift', data);
}), _defineProperty(_live, "randomRecommend", function randomRecommend(data) {
  // 课程推荐
  return Vue.http.post('/rest/ysh/wx/course/randomRecommend', data);
}), _live);
/*
 * 评论
 * */

export var comment = {
  getDefaultComments: function getDefaultComments(data) {
    //获取默认评论
    return Vue.http.post('/comment/defaultOrderCourseComments', data);
  },
  getRecComments: function getRecComments(data) {
    //按评论推荐排序
    return Vue.http.post('/comment/recommendOrderCourseComments', data);
  },
  // getComments: (data) => { //获取
  //   return Vue.http.post('/comment/getComments', data)
  // },
  getComments: function getComments(data) {
    //获取
    return Vue.http.post('/rest/ysh/wx/comment/list', data);
  },
  addComment: function addComment(data) {
    //提交
    return Vue.http.post('/rest/ysh/wx/comment/insert', data);
  },
  delete: function _delete(data) {
    //删除
    return Vue.http.post('/comment/delete', data);
  },
  accusation: function accusation(data) {
    //举报
    return Vue.http.post('/rest/ysh/wx/comment/accusation', data);
  },
  like: function like(data) {
    // 点赞
    return Vue.http.post('/rest/ysh/wx/comment/like', data);
  },
  collection: function collection(data) {
    //收藏 userId id type 1资讯 2病例 3帖子 4课程  operation 1收藏 2取消
    return Vue.http.post('/rest/ysh/wx/info/collect', data);
  },
  unCollection: function unCollection(data) {
    // 取消收藏
    return Vue.http.post('/rest/ysh/wx/course/unCollection', data);
  }
};
/*
 * 搜索
 * @params {keyword,from,size}
 * */

export var search = {
  news: function news(data) {
    //头条
    return Vue.http.post('/wxSearch/news', data);
  },
  course: function course(data) {
    //搜索课程
    return Vue.http.post('/rest/ysh/wx/course/search', data);
  },
  channel: function channel(data) {
    //搜索学院
    return Vue.http.post('/wxSearch/channel', data);
  },
  hotSearch: function hotSearch(data) {
    // 热门搜索
    return Vue.http.post('/forumPage/hotSearch', data);
  },
  searchQuestion: function searchQuestion(data) {
    // 搜索帖子
    return Vue.http.post('/forumPage/searchQuestion', data);
  }
};
/*
 * 个人中心
 * */

export var personal = {
  center: function center() {
    //用户信息
    return Vue.http.post('/user/personalCenter');
  },
  recordingLectures: function recordingLectures(data) {
    // 听课记录
    return Vue.http.post('/rest/ysh/wx/userCenter/queryListenCourse', data);
  },
  queryChannelSubscribe: function queryChannelSubscribe() {
    // 我的收藏课程 头条
    return Vue.http.post('/rest/ysh/wx/userCenter/queryChannelSubscribe');
  },
  // collectionNew: () => { // 我的收藏头条
  //   return Vue.http.post('/center/collectionNews')
  // },
  remindOpen: function remindOpen(data) {
    // 微信每日任务-订阅/取消订阅
    return Vue.http.post('/remindPushTask/remindOpen', data);
  },
  pushInfo: function pushInfo(data) {
    // 微信每日任务-订阅推送信息
    return Vue.http.post('/remindPushTask/pushInfo', data);
  }
};
/*
 * 超级面对面
 * */

export var facing = {
  category: function category() {
    // 学科集合
    return Vue.http.post('/rest/ysh/wx/cjmdm/getListCategory');
  },
  list: function list(data) {
    // 专家课程list
    return Vue.http.post('/rest/ysh/wx/cjmdm/getList', data);
  },
  bannerList: function bannerList(data) {
    // banner
    return Vue.http.post('/rest/ysh/wx/cjmdm/bannerList', data);
  },
  specialList: function specialList(data) {
    // 专题集合
    return Vue.http.post('/rest/ysh/wx/cjmdm/specialList', data);
  },
  initSpecial: function initSpecial(data) {
    // 专题详情-列表
    return Vue.http.post('/rest/ysh/wx/cjmdm/specialInfo', data);
  }
};
/*
 * 今日医疗圈
 */

export var medicalCircle = {
  list: function list(data) {
    // 我的收藏头条
    return Vue.http.get('/rest/ysh/wx/dailyInformation/data' + data);
  }
};
/*
 * 周末科室推送
 */

export var weekendSend = {
  list: function list(data) {
    // 我的收藏头条
    return Vue.http.get('/rest/ysh/wx/weekendCourse/indexList' + data);
  }
};
/*
 * 推送
 */

export var pushTemp = {
  todayArticles: function todayArticles(data) {
    // 今日推送文章列表
    return Vue.http.post('/rest/ysh/wx/articles/todayArticles', data);
  }
};
/****************************************************问卷****************************************************************/

export var questionnaire = {
  questionnaireData: function questionnaireData(data) {
    return request.post("".concat(baseUrl, "/questionnaire/questionnaireData"), data);
  },
  answerQuestionnaire: function answerQuestionnaire(data) {
    return request.post("".concat(baseUrl, "/questionnaire/answerQuestionnaire"), data);
  }
};
export var fileUpload = function fileUpload(data) {
  return upload("".concat(baseUrl, "/upload/fileUpload"), data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}; // 医生汇接口打通saas

export var yshJumpSaas = function yshJumpSaas(data) {
  return request({
    url: "/rest/ysh/wx/channel/yshJumpSaas",
    method: 'post',
    data: data,
    notUseQs: true,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  });
}; // 获取微信

export var jsApiSignature = function jsApiSignature(data) {
  return request.post("/rest/ysh/wx/wxIndex/jsApiSignature", data);
};